import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=1650993c&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650993c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1650993c')) {
      api.createRecord('1650993c', component.options)
    } else {
      api.reload('1650993c', component.options)
    }
    module.hot.accept("./recharge.vue?vue&type=template&id=1650993c&scoped=true", function () {
      api.rerender('1650993c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/recharge.vue"
export default component.exports